/**
 * Development URL:
 * @url - https://sst-backend-xf8ho.ondigitalocean.app/api/
 * // const BASE_URL = 'https://sstback.emision.dev/api/'
 *
 * Testing URL:
 * @url - https://sst-testing-backend-dtw86.ondigitalocean.app/api/
 *
 * Prod URL:
 * @url - https://sst-production-backend-s943p.ondigitalocean.app/api/
 */

import authHeader from './headers'

const BASE_URL = process.env.VUE_APP_BASE_URL || 'https://sst-production-backend-s943p.ondigitalocean.app/api/'

/**
 * Method to facilitate API requests
 * @param {URL} url Represents the URL where the API to which the requests will be made is located.
 * @param {Request} method The different types of API requests that can be made (POST, GET, PUT, DELETE, and others). By default "GET" is set.
 * @param {Headers} header The headers that will be sent with the request.
 * @param {Object} body Corresponds to the parameters to be sent to the API. These are converted into a JSON before being sent.
 * @returns Returns the API response.
 */
async function service(url, method, header, body) {
  const options = {
    method: method,
    headers: header,
  }
  if (body !== undefined && method !== 'GET') {
    options.body = JSON.stringify(body)
  }
  let response = await fetch(url, options)
  // Algunos endpoints (SST.companies/list/{id} cuando no encuentra, SSO calls con
  // token dev, etc.) devuelven HTTP 200 con body vacio. response.json() en ese caso
  // tira SyntaxError 'Unexpected end of JSON input'. Lo manejamos devolviendo null
  // para que el caller pueda hacer `if (!response) return` sin estallar.
  const text = await response.text()
  if (!text) return null
  try {
    return JSON.parse(text)
  } catch (e) {
    console.warn('http.js: respuesta no es JSON valido para', url, '->', text.slice(0, 100))
    return null
  }
}

/**
 * Method to facilitate API requests
 * @param {URL} url Represents the URL where the API to which the requests will be made is located.
 * @param {Request} method The different types of API requests that can be made (POST, GET, PUT, DELETE, and others). By default "GET" is set.
 * @param {Object} body Corresponds to the parameters to be sent to the API. These are converted into a JSON before being sent.
 * @returns Returns the API response.
 */
export default async function http(url, method, body) {
  const fullUrl = BASE_URL + url
  try {
    let response = await service(
      fullUrl,
      method || 'GET',
      { 'Accept': 'application/json', 'Content-Type': 'application/json', ...authHeader() },
      body
    )
    return response
  } catch (error) {
    console.log('[http error]', method || 'GET', fullUrl, error)
  }

}

export function url(url) {
  return BASE_URL + url
}

export function getBase() {
  return BASE_URL
}
